import { SparkDAO } from 'sparkello-core';
import { VuexSparkStore, WebSparkMapper, WebCommentMapper } from '../index';

import { auth, firestore, functions } from 'firebase/app';
import DocumentSnapshot = firestore.DocumentSnapshot;
import FieldValue = firestore.FieldValue;

export class SparkWebDAO extends SparkDAO<DocumentSnapshot, FieldValue,
                                          typeof auth, typeof firestore, typeof functions> {
  private static instance: SparkWebDAO;

  public static getInstance(): SparkWebDAO {
    if (!SparkWebDAO.instance) {
      SparkWebDAO.instance = new SparkWebDAO();
    }
    return this.instance;
  }

  public constructor() {
    super(new WebSparkMapper(),
      new WebCommentMapper(),
      new VuexSparkStore(),
      auth,
      firestore,
      functions);
  }
}
